var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg403 = function Svg403(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 519 518"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64FCD9",
    fillRule: "evenodd",
    d: "M160.107 416.216c62.444 45.839 124.695-16.752 182.361 11.433 31.567 15.429 90.865 55.832 134.204-60.069 27.708-74.928-34.198-119.532-119.682-107.86-23.989.328-39.552-8.406-54.432-23.265s-24.321-59.801-64.983-83.581c-122.366-71.56-311.322 91.679-77.468 263.342",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2A2A",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M210.142 355.004h35.212v48.417l-4.401 8.803h-39.614c-2.641 0-4.401-1.761-4.401-4.402v-13.204c0-6.162 4.401-11.884 10.563-12.765l2.641-.44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2A2A",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M205.741 381.413h28.61c6.162 0 11.004 2.641 11.004 8.803v4.402M297.733 355.004h-35.212v52.818c0 2.641 1.761 4.402 4.402 4.402h48.417c2.64 0 4.401-1.761 4.401-4.402v-13.204c0-6.162-4.401-11.884-10.564-12.765l-11.444-.44z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M272.644 46.016c0 3.08-2.641 5.282-5.282 5.282-3.081 0-5.281-2.641-5.281-5.282 0-3.081 2.64-5.282 5.281-5.282 3.082 0 5.282 2.64 5.282 5.282M295.532 46.016c0 3.08-2.641 5.282-5.282 5.282-3.081 0-5.282-2.641-5.282-5.282 0-3.081 2.641-5.282 5.282-5.282s5.282 2.64 5.282 5.282"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2E2A2A",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M205.741 107.637V54.819C205.741 25.769 229.51 2 258.56 2s52.818 23.768 52.818 52.819v52.818c20.688 70.425 40.935 141.29 61.622 211.714-3.521 2.201-14.085 8.803-29.05 7.483-10.564-.88-17.606-5.282-21.128-7.483-2.641 1.761-10.563 7.483-22.447 7.483-12.325 0-20.688-5.722-22.889-7.483-2.64 2.201-11.003 7.923-23.328 7.483-11.004 0-18.926-4.842-21.567-7.043-2.641 1.761-10.564 7.043-22.008 7.043-11.004 0-18.927-4.842-21.568-7.043-2.64 1.761-10.563 7.043-21.567 7.043-11.884 0-19.807-5.722-22.448-7.483 19.367-70.424 40.054-141.289 60.741-211.714Z"
  })));
};
export default Svg403;